<template>
    <div class="annotations-tab">
        <h3 class="mt-0">{{ $l10n.__('Commentaires') }}</h3>
        <div>
            <div
                v-if="useCategories && categories.length > 0"
                id="annotations-categories"
                class="acenter"
            >
                <ul>
                    <li
                        v-for="(category, index) in categories"
                        :key="index"
                        :class="[params.relatedtype == category.syscode ? 'selected-category' : '']"
                        @click="getAnnotationByType(category.syscode)"
                    >
                        <el-tooltip :content="category.label" placement="bottom" effect="light">
                            <i :class="`fa ${category.fa} fa-15`" />
                        </el-tooltip>
                    </li>
                </ul>
            </div>
            <div>
                <div v-if="enableAnnotForm">
                    <annotation-form
                        :linkedid="parseInt(linkedid)"
                        :linkedtype="relatedtype"
                        :data="ttData"
                        :corptype="corptype"
                        @reloadAnnotations="getAnnotations"
                    >
                    </annotation-form>
                </div>
                <div v-if="!loadingList" class="prelative annotations-tab__list">
                    <annotations-list
                        v-if="list.length > 0"
                        :list="list"
                        :data="ttData"
                        :corptype="corptype"
                        @delete="openModalDelete"
                    />
                    <div v-else class="placeholder annotations-tab__no-comments">
                        <p>{{ $l10n.__('Pas de commentaires.') }}</p>
                    </div>
                </div>
                <div v-else class="prelative mh-6">
                    <preloader :display="loadingList" />
                </div>
            </div>
        </div>

        <CompassDialog
            :visible.sync="deleteModal"
            size="small"
            :title="$t.__('common.actions.delete_message')"
        >
            <template slot="default">
                <div class="dialog__default">
                    <p class="typographies-paragraph-medium-regular">
                        {{
                            $l10n.__('Confirmez-vous vouloir faire disparaître votre commentaire ?')
                        }}
                    </p>
                    <ul class="typographies-paragraph-medium-regular">
                        <li>
                            -
                            {{ $l10n.__('Il n’apparaitra plus pour aucun de vos collaborateurs.') }}
                        </li>
                        <li>- {{ $l10n.__('Ceci est une action définitive.') }}</li>
                    </ul>
                </div>
            </template>
            <template slot="footer">
                <div class="dialog__footer">
                    <CompassButton
                        :label="$t.__('common.actions.cancel')"
                        type="secondary"
                        @click="deleteModal = false"
                    />
                    <CompassButton
                        :label="$t.__('common.actions.delete')"
                        type="primary-destructive"
                        class="ml-3"
                        @click="deleteAnnotation()"
                    />
                </div>
            </template>
        </CompassDialog>
    </div>
</template>

<script>
import AnnotationForm from 'vcomponents/forms/AnnotationForm.vue';
import AnnotationsList from 'vcomponents/utilities/AnnotationsList.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import AnnotationService from 'Services/Annotations/AnnotationService';

const linkedTypesUseCategories = ['third'];

export default {
    components: {
        AnnotationForm,
        AnnotationsList,
        Preloader,
    },
    props: {
        linkedid: {
            type: [String, Number],
            required: false,
            default: '',
        },
        linkedtype: {
            type: String,
            required: false,
            default: '',
        },
        relatedid: {
            type: [String, Number],
            required: false,
            default: '',
        },
        relatedtype: {
            type: String,
            required: false,
            default: '',
        },
        thirdtype: {
            type: String,
            required: false,
            default: '',
        },
        corptype: {
            type: String,
            required: false,
            default: '',
        },
        load: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            params: {
                indexLimit: 0,
                relatedid: this.relatedid,
                relatedtype: this.relatedtype,
                linkedtype: this.linkedtype,
                linkedid: this.linkedid,
                thirdtype: this.thirdtype,
                annotid: '%annotId%',
            },
            list: [],
            ttData: {},
            loadingList: true,
            deleteModal: false,
            annotToDelete: null,
            categories: [],
            enableAnnotForm: false,
            annotationService: new AnnotationService(),
        };
    },
    computed: {
        useCategories() {
            return linkedTypesUseCategories.includes(this.relatedtype);
        },
    },
    created() {
        if (this.load) {
            this.getAnnotations();
        }
    },
    events: {
        'annotation-tab:load': 'reload',
    },
    methods: {
        reload() {
            this.loadingList = true;
            this.getAnnotations();
        },
        getAnnotations(onlyUpdateList = false) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(
                    this.$router.resolve({ name: `legacy.annotations` }).href,
                    this.params,
                    (response) => {
                        this.list = response.annotlist;
                        if (!onlyUpdateList) {
                            this.ttData = response.timetracking;
                            this.categories = response.annotheaders;
                            this.enableAnnotForm = true;
                        }
                        this.loadingList = false;

                        resolve();
                    },
                    (error) => {
                        reject(error);
                    },
                );
            });
        },
        getAnnotationByType(type) {
            this.loadingList = true;
            this.params.relatedtype = type;
            this.params.relatedid = 0;
            this.params.linkedtype = this.linkedtype;
            this.enableAnnotForm = false;
            if (type == 'third') {
                this.params.relatedid = this.linkedid;
                this.params.linkedtype = this.thirdtype;
                this.enableAnnotForm = true;
            }
            this.getAnnotations(true);
        },
        openModalDelete(payload) {
            this.deleteModal = true;
            this.annotToDelete = payload;
        },
        deleteAnnotation() {
            this.annotationService.deleteAnnotation(this.annotToDelete.id).then((response) => {
                this.deleteModal = false;
                let index = 0;
                let indexParent = 0;
                if (parseInt(this.annotToDelete.parentid) > 0) {
                    indexParent = this.list.findIndex(
                        (annot) => annot.datas.id == this.annotToDelete.parentid,
                    );
                    index = this.list[indexParent].subannots.findIndex(
                        (subannot) => subannot.id == this.annotToDelete.id,
                    );
                    this.list[indexParent].subannots.splice(index, 1);
                } else {
                    index = this.list.findIndex((annot) => annot.datas.id == this.annotToDelete.id);
                    this.list.splice(index, 1);
                }
                this.annotToDelete = null;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.annotations-tab {
    .dialog {
        &__default {
            padding-bottom: var(--spacing-4);
            p {
                margin: 0 0 var(--spacing-3);
            }
            ul {
                margin: 0;
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 var(--spacing-6) var(--spacing-4);
        }
    }

    &__no-comments,
    &__list {
        margin-top: var(--spacing-5);
    }
}
</style>
